"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const useConstructor = (callback) => {
    const hasBeenCalled = React.useRef(false);
    if (hasBeenCalled.current)
        return;
    callback === null || callback === void 0 ? void 0 : callback();
    hasBeenCalled.current = true;
};
exports.default = useConstructor;
